module.exports = __webpack_public_path__ + "img/itlab.1561d18d.png";